angular.module("EICDataStream3.directives",
  [
    "ngResource",
    "infinite-scroll",
    //"mgcrea.ngStrap",
    "ui.directives",
    'ui.config',
    "jqShowEffect",
    "truncate",
    'eic.multiselect'
  ]) //"EICDataStream3.services",
  .config(function() {
  })
//-------------------------------------------------------------------------
// Directives
//-------------------------------------------------------------------------

//-------------------------------------------------------------------------
// onScroll
// Register the scrollevent on an element and call the given function
// when the scroll event fires
//-------------------------------------------------------------------------
//EICDataStream3Directives.directive('onScroll', [
//  function () {
//    return {
//      link: function (scope, element, attr) {
//        var scrollAction = attr.onScroll;
//        element.bind('scroll', function (event) {
//          scope.$eval(scrollAction);
//        });
//      }
//    };
//  }]);


//-------------------------------------------------------------------------
// onScrollActions
// ---------------
// A flexible scroll directive that fires under controllable circumstances
// Usage:
// on-scroll-actions="{
//   'onScrollFirst':'onScrollFirst()',
//   'onScroll':'onScroll()',
//   'onScrollToTop':'onScrollToTop()'
// }"
//-------------------------------------------------------------------------
  .directive('onScrollActions',
  [
    function() {
      return {
        link: function(scope, element, attr) {

          // a closure keeps the values of the actions
          // in the case of scroll once, this allows the
          // action to  be switched off after first call
          var scrollActions = eval("(" + attr.onScrollActions + ")");
          var onScrollFirst = scrollActions.onScrollFirst;
          var onScroll = scrollActions.onScroll;
          var onScrollToTop = scrollActions.onScrollToTop;

          var bindScroll = function() {
            element.bind('scroll',
              function(event) {
                if (element.scrollTop() === 0) { // scroll hits top of container
                  scope.$eval(onScrollToTop);
                } else if (onScrollFirst) {
                  scope.$eval(onScrollFirst);
                  scope.$eval(onScroll);
                  onScrollFirst = "";
                } else {
                  scope.$eval(onScroll);
                }
                scope.$apply();

              });
          }();

        }
      };
    }
  ])
  .directive('sorted',
    function() {
      return {
        scope: true,
        transclude: true,
        template: '<a ng-click="do_sort()" ng-transclude></a>' +
          '<span ng-show="do_show(true)"><i class="glyphicon glyphicon-circle-arrow-down"></i></span>' +
          '<span ng-show="do_show(false)"><i class="glyphicon glyphicon-circle-arrow-up"></i></span>',
        controller: [
          '$scope', '$element', '$attrs',
          function($scope, $element, $attrs) {

            // if the default sort has been set, convert its value to true/false
            // if undefined, the value is set to  false (ie, an ascending sort)
            // This should cause an unsupplied value to  evaluate to  'undefined'
            // which is !== 'true'.
            var defaultSortDesc = (String($attrs.defaultSortDesc).toLowerCase() === "true");

            $scope.sort = { sortField: $attrs.sorted, sortDesc: defaultSortDesc }


            $scope.do_sort = function() {
              if ($scope.$parent.currentSortField === $scope.sort.sortField) {
                $scope.sort.sortDesc = !$scope.sort.sortDesc;
              } else {
                $scope.sort.sortDesc = defaultSortDesc;
              }
              //searchService.sort_by($scope.sort);
              $scope.$parent.currentSortField = $attrs.sorted;

              $scope.$emit("SORT_CHANGED", $scope.sort);
            };

            $scope.do_show = function(asc) {
              return (asc !== $scope.sort.sortDesc) && ($scope.$parent.currentSortField === $scope.sort.sortField);
            };
          }
        ]
      };
    });






